import $ from "jquery";

const addStartAndEnd = (content)=>{
    if(!content){
        return content;
    }
    let $container = $(`<div>${content}</div>`);
    let children = $container.children();
    if(children.length > 1){
        $(children[0]).addClass("vsbcontent_start");
    }
    for(let i = children.length - 1; i > 0; i -- ){
        if($(children[i]).text()){
            $(children[i]).addClass("vsbcontent_end");
            break;
        }
    }
    return $container.html();
};
export default addStartAndEnd;